export default function passwordInputType(isVisible: boolean) {
  return isVisible ? 'text' : 'password';
}
